import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';

export interface SelectProps extends StandaloneComponentProps {
  label: string;
  items: (string | number)[];
  onChange: (value: any) => void;
  defaultValue?: string | number;
}

export const Select: StandaloneComponent<SelectProps> = ({ label, items, onChange, defaultValue }) => {
  return (
    <label className="space-x-2">
      <span>{label}:</span>
      <select onChange={({ target: { value } }) => onChange(value)} {...{ defaultValue }}>
        {items.map((variant) => (
          <option key={variant} value={variant}>
            {variant}
          </option>
        ))}
      </select>
    </label>
  );
};
